import React from 'react';
import '@/index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider }     from '@/contexts/AuthContext';
import { ThemeProvider }    from '@/contexts/ThemeContext';
import { ProtectedRoute }   from '@/components/ProtectedRoute';
import { Layout }           from '@/components/Layout';
import { LoginPage }        from '@/pages/LoginPage';
import { RegisterPage }     from '@/pages/RegisterPage';
import { DashboardPage }    from '@/pages/DashboardPage';
import { PersonsPage }      from '@/pages/PersonsPage';
import { PersonDetailPage } from '@/pages/PersonDetailPage';
import { FamiliesPage }     from '@/pages/FamiliesPage';
import { FamilyDetailPage } from '@/pages/FamilyDetailPage';
import { PlacesPage }       from '@/pages/PlacesPage';
import { TreePage }         from '@/pages/TreePage';
import { EventsPage }       from '@/pages/EventsPage';
import { ProfilePage }      from '@/pages/ProfilePage';
import { AdminUsersPage }   from '@/pages/AdminUsersPage';
import { ContactPage }      from '@/pages/ContactPage';
import { AdminContactPage } from '@/pages/AdminContactPage';


const P = ({ children }) => (
  <ProtectedRoute><Layout>{children}</Layout></ProtectedRoute>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login"    element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            <Route path="/dashboard"        element={<P><DashboardPage /></P>} />
            <Route path="/persons"          element={<P><PersonsPage /></P>} />
            <Route path="/persons/:handle"  element={<P><PersonDetailPage /></P>} />
            <Route path="/families"         element={<P><FamiliesPage /></P>} />
            <Route path="/families/:handle" element={<P><FamilyDetailPage /></P>} />
            <Route path="/places"           element={<P><PlacesPage /></P>} />
            <Route path="/tree"             element={<P><TreePage /></P>} />
            <Route path="/events"           element={<P><EventsPage /></P>} />
            <Route path="/profile"          element={<P><ProfilePage /></P>} />
            <Route path="/admin/users"      element={<P><AdminUsersPage /></P>} />
            <Route path="/contact"          element={<P><ContactPage /></P>} />
            <Route path="/admin/contact"    element={<P><AdminContactPage /></P>} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;